var exports = {
  "kL": "x2b2fbebb--98323b--container",
  "DD": "x2b2fbebb--98323b--title",
  "Qq": "x2b2fbebb--98323b--text",
};

module.exports = exports;
